var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCocktailGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 19.7001L23 8.1001H3L13 19.7001ZM13 19.7001L23 8.1001H3L13 19.7001Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 19.7002V28.7002",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3999 28.7002H19.5999",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1001 14.7998H16.9001",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8999 8.10001C17.8999 7.09133 18.199 6.1053 18.7594 5.26661C19.3198 4.42792 20.1163 3.77423 21.0482 3.38822C21.9801 3.00221 23.0056 2.90121 23.9949 3.098C24.9842 3.29478 25.8929 3.78053 26.6061 4.49378C27.3194 5.20703 27.8051 6.11574 28.0019 7.10505C28.1987 8.09435 28.0977 9.1198 27.7117 10.0517C27.3257 10.9836 26.672 11.7801 25.8333 12.3405C24.9946 12.9009 24.0086 13.2 22.9999 13.2C21.7761 13.194 20.599 12.7302 19.6999 11.9",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCocktailGlass);
export default __webpack_public_path__ + "static/media/cocktail_glass.acb93daa22f997109b6541539eeb925b.svg";
export { ForwardRef as ReactComponent };